import React, { useCallback, useRef, useState } from 'react';
import { FiPhone, FiMail, FiUser, FiLock } from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { Link, useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import Loader from 'react-loader-spinner';
import axios from 'axios';
import api from '../../services/api';
import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';

import getValidationErrors from '../../utils/getValidationErrors';
import { phoneMask } from '../../utils/handlePhoneMask';



import logoImg from '../../assets/logoCoruja.png';
import logoUnibes from '../../assets/unibes.png';


import Input from '../../components/Input';
import Button from '../../components/Button';

import { Container, Content, AnimationContainer, Background, Apoio } from './styles';

interface SignUpFormData {
  name: string;
  surname: string;
  email: string;
  password: string;
  phone: string;
  passwordConfirmation: string;
  stripe_id: string;
  planos_id: string;
}

interface StripeResponse {
  data: {
    id: string;
  };
}

const SingUp: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const formRef = useRef<FormHandles>(null);

  const [phone, setPhone] = useState('');
  const handlePhone = useCallback((e: any) => {
    setPhone(phoneMask(e.target.value));
  }, []);



  const { singIn } = useAuth();
  const { addToast } = useToast();
  const history = useHistory();
  const handleSubmit = useCallback(
    async (data: SignUpFormData) => {
      try {
        setLoading(true);
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          name: Yup.string().required('Nome obrigatório'),
          surname: Yup.string().required('Sobrenome obrigatório'),
          email: Yup.string()
            .required('E-mail obrigatório')
            .email('Digite um e-mail válido'),
          phone: Yup.string()
            .required('Telefone obrigatório').min(15, 'No mínimo 9 dígitos'),
          password: Yup.string().min(6, 'No mínimo 6 dígitos'),
          passwordConfirmation: Yup.string().oneOf(
            [Yup.ref('password')],
            'Senhas não conferem',
          ),
        });
        await schema.validate(data, {
          abortEarly: false,
        });

        const response: StripeResponse = await axios.post(
          'https://recreativa.herokuapp.com/create_customer',
          {
            name: `${data.name} ${data.surname}`,
            email: data.email,
          },
        );

        await api.post('/register', {
          name: data.name,
          sobrenome: data.surname,
          email: data.email,
          celular: data.phone,
          password: data.password,
          planos_id: 4,
          origens_qrcodes_id: 8,
          stripe_id: response.data.id,
        });

        await singIn({
          email: data.email,
          password: data.password,
        });

        setLoading(false);
        addToast({
          type: 'success',
          title: 'Cadastro realizado com sucesso!',
          description: '',
        });
        history.push('/home');
      } catch (err) {
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }
        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description: 'Ocorreu um erro ao fazer cadastro, tente novamente',
        });
      }
    },
    [addToast, history],
  );

  return (
    <Container>
      <Background />

      <Content>
        <AnimationContainer>
          <img src={logoImg} alt="Logo Coruja" width="200px" />
          <Apoio >
            <h3>Apoio:</h3>
            <div >
          {/* <img src={logoImg} alt="Logo Coruja" width="100px" /> */}
          <img src={logoUnibes} alt="Logo Unibes" width="100px" />
          </div>


          </Apoio>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <h1>Faça seu cadastro</h1>
            <Input name="name" icon={FiUser} placeholder="Nome" />
            <Input name="surname" icon={FiUser} placeholder="Sobrenome" />
            <Input name="email" icon={FiMail} placeholder="E-mail" />
            <Input name="phone" icon={FiPhone} value={phone} onChange={handlePhone} placeholder="Telefone" />
            <Input
              name="password"
              icon={FiLock}
              type="password"
              placeholder="Senha"
            />
            <Input
              name="passwordConfirmation"
              icon={FiLock}
              type="password"
              placeholder="Confirmar senha"
            />
            <Button type="submit" style={{ marginBottom: 10 }}>
              Cadastrar
            </Button>
            <Loader
              type="Oval"
              color="#984A94"
              height={50}
              width={50}
              visible={loading}
            />
          </Form>

        </AnimationContainer>
      </Content>
    </Container>
  );
};

export default SingUp;
